import { Component, Input } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'app-custom-item-card-body-wish-list',
  templateUrl: './custom-item-card-body-wish-list.component.html'
})
export class CustomItemCardBodyWishListComponent {

  @Input() product: IItemWishList = new IItemWishList;
  @Input() showCant: boolean = false;
  utils = utils;


  deleteProductCar: boolean = false;

  constructor(){}

  showTotalPrice() {
    const price = this.product.product.isOnDiscount
      ? this.product.product.priceDiscount
      : this.product.product.price;

    return price;
  }
}
